import {BaseContainerModel} from '../../base-container.model';
import {
  bl_fi_cash_stmt_line_RowClass
} from '../../../dbschema/index';

export class BankStatementLineContainer extends BaseContainerModel {
  bl_fi_cash_stmt_line: bl_fi_cash_stmt_line_RowClass = new bl_fi_cash_stmt_line_RowClass();

}
